import { render } from "./FloatingAI.vue?vue&type=template&id=fa0aedfc&scoped=true"
import script from "./FloatingAI.vue?vue&type=script&lang=js"
export * from "./FloatingAI.vue?vue&type=script&lang=js"

import "./FloatingAI.vue?vue&type=style&index=0&id=fa0aedfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0aedfc"]])

export default __exports__